// -----------------------------------------------------------------------------
// Central brand configuration.
// Change the brand name, tagline, links, contact details and social handles
// here and they will propagate across the entire storefront.
// -----------------------------------------------------------------------------
export const brand = {
  name: "ÉLORA JEWELS",
  shortName: "ÉLORA",
  tagline: "Timeless Jewellery. Made to Shine.",
  currency: "INR",
  currencySymbol: "₹",
  email: "hello@elorajewels.store",
  phone: "+91 8968676532",
  address: "12 Linking Road, Bandra West, Mumbai 400050",
  freeShippingThreshold: 25000,
};

export const announcements = [
  "Complimentary insured shipping across India",
  "Use code SHINE15 for 15% off your first order",
  "Handcrafted · Hallmarked · Certified",
];

export const mainNav = [
  { label: "Home", to: "/", testId: "nav-home-link" },
  { label: "Shop", to: "/shop", testId: "nav-shop-link" },
  { label: "Collections", to: "/collections", testId: "nav-collections-link" },
  { label: "New Arrivals", to: "/collections/new-arrivals", testId: "nav-new-arrivals-link" },
  { label: "Best Sellers", to: "/collections/best-sellers", testId: "nav-best-sellers-link" },
  { label: "About", to: "/about", testId: "nav-about-link" },
  { label: "Contact", to: "/contact", testId: "nav-contact-link" },
];

export const footerColumns = [
  {
    title: "Shop",
    links: [
      { label: "All Jewellery", to: "/shop" },
      { label: "New Arrivals", to: "/collections/new-arrivals" },
      { label: "Best Sellers", to: "/collections/best-sellers" },
      { label: "Collections", to: "/collections" },
    ],
  },
  {
    title: "Collections",
    links: [
      { label: "Necklaces", to: "/collections/necklaces" },
      { label: "Earrings", to: "/collections/earrings" },
      { label: "Rings", to: "/collections/rings" },
      { label: "Bracelets", to: "/collections/bracelets" },
      { label: "Bangles", to: "/collections/bangles" },
      { label: "Jewellery Sets", to: "/collections/jewellery-sets" },
    ],
  },
  {
    title: "Customer Care",
    links: [
      { label: "Contact Us", to: "/contact" },
      { label: "FAQ", to: "/faq" },
      { label: "Shipping & Returns", to: "/faq#shipping" },
      { label: "My Account", to: "/account" },
    ],
  },
  {
    title: "About",
    links: [
      { label: "Our Story", to: "/about" },
      { label: "Craftsmanship", to: "/about#craftsmanship" },
      { label: "Privacy Policy", to: "/faq#privacy" },
      { label: "Terms", to: "/faq#terms" },
    ],
  },
];

export const social = [
  { label: "Instagram", href: "https://www.instagram.com/by_elorajewels_", icon: "instagram" },
  { label: "Facebook", href: "https://www.facebook.com/share/1FYDRxq6G5/", icon: "facebook" },
  { label: "Threads", href: "https://www.threads.com/@by_elorajewels_", icon: "threads" },
];

export const instagramHandle = "@by_elorajewels_";

export const whyChooseUs = [
  { title: "Premium Quality", description: "Hallmarked gold and certified stones, hand-finished by master artisans.", icon: "gem" },
  { title: "Secure Packaging", description: "Every piece arrives insured in signature ÉLORA packaging.", icon: "shield-check" },
  { title: "Fast Shipping", description: "Complimentary, tracked delivery across India in 3-6 days.", icon: "truck" },
  { title: "Easy Returns", description: "15-day hassle-free returns and exchanges on all orders.", icon: "rotate-ccw" },
];
